"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { key: 1 };
var vue_3 = require("vue");
var use_pageNavigation_1 = require("@/composables/use-pageNavigation");
var publications_query_1 = require("@/queries/publications.query");
var Card_vue_1 = require("@/components/Card.vue");
var CardGrid_vue_1 = require("@/components/CardGrid.vue"); // explicit import needed, auto import is flaky on production build
var search_query_1 = require("@/queries/search.query");
var FaqCardPlaceholder_vue_1 = require("@/components/FaqCardPlaceholder.vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Publications',
    setup: function (__props) {
        var _this = this;
        var redirectNoPublications = function () {
            var _a;
            if (!((_a = publications_query_1.publicationData.value) === null || _a === void 0 ? void 0 : _a.publication)) {
                (0, use_pageNavigation_1.startContactForm)("fallback");
            }
        };
        var isEmptySearchResult = (0, vue_3.computed)(function () { return !search_query_1.resultResponse.value || search_query_1.resultResponse.value.length === 0; });
        (0, vue_3.onBeforeMount)(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                redirectNoPublications();
                return [2 /*return*/];
            });
        }); });
        return function (_ctx, _cache) {
            var _a, _b;
            return ((0, vue_2.unref)(publications_query_1.fetching))
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(FaqCardPlaceholder_vue_1.default, { key: 0 }))
                : ((0, vue_2.unref)(publications_query_1.error))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, (0, vue_2.toDisplayString)(_ctx.$t("generalError")), 1))
                    : (((_b = (_a = (0, vue_2.unref)(publications_query_1.publicationData)) === null || _a === void 0 ? void 0 : _a.publication) === null || _b === void 0 ? void 0 : _b.collections) && isEmptySearchResult.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(CardGrid_vue_1.default, { key: 2 }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(publications_query_1.publicationData).publication.collections, function (collection, i) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Card_vue_1.default, {
                                        id: collection.id,
                                        key: i,
                                        collection: collection
                                    }, null, 8, ["id", "collection"]));
                                }), 128))
                            ]; }),
                            _: 1
                        }))
                        : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
